import {Component, inject} from '@angular/core';
import {TypeTestimonialWithoutUnresolvableLinksResponse} from '../../../../core/types/contentful.types';
import {ContentfulService} from '../../../../core/services/contentful.service';
import {toSignal} from '@angular/core/rxjs-interop';

@Component({
    selector: 'wci-customer',
    imports: [],
    templateUrl: './customer-voices.component.html',
    styles: ``,
})
export class CustomerVoicesComponent {
    service = inject(ContentfulService);
    items = toSignal<TypeTestimonialWithoutUnresolvableLinksResponse[]>(this.service.getTestimonials());
}
